import type { EventBus } from "../events/EventBus";
import type { KnowledgeGraph } from "../../knowledge/KnowledgeGraph";
import type { ArtifactRegistry } from "../../artifacts/ArtifactDefinition";
import type { RecipeRegistry } from "../../crafting/RecipeRegistry";
import type { World } from "../../world/World";

export interface CommandContext {
  readonly world: World;
  readonly events: EventBus;
  readonly knowledge: KnowledgeGraph;
  readonly artifacts: ArtifactRegistry;
  readonly recipes: RecipeRegistry | undefined;
}

export interface Command {
  execute(context: CommandContext): void;
}

/** Applies commands against a fixed context and notifies a listener (used to trigger autosave). */
export class CommandBus {
  constructor(
    private readonly context: CommandContext,
    private readonly onApplied?: (command: Command) => void,
  ) {}

  execute(command: Command): void {
    command.execute(this.context);
    this.onApplied?.(command);
  }
}
